function CommonService($http, $httpParamSerializer, $state, base64, toastr, AppSettings) {
  'ngInject';

  let proxyApiUrl;

  if (process.env.NODE_ENV === 'production') {
    proxyApiUrl = AppSettings.apiUrl.production;
  } else {
    proxyApiUrl = AppSettings.apiUrl.development;
  }

  const service = {};

  // post, get 모두 URL 을 base64_encode + encodeURIComponent 처리함
  // get 방식일 경우 URL 자체에 parameter 가 많을 수도 있어서 proxy 에서 parameter 를 제대로 처리할 수 있도록 위와 같은 처리를 함

  // service.post = function (url, params) {
  //   return new Promise((resolve, reject) => {
  //     $http({
  //       method: 'POST',
  //       url: url,
  //       data: $httpParamSerializer(params),
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded'
  //       }
  //     }).then((data) => {
  //       resolve(data.data);
  //     }, (err, status) => {
  //       reject(err, status);
  //     });
  //   });

  // };

  // service.post = function (url, params) {
  //   return $http.post(
  //     url, 
  //     { data: $httpParamSerializer(params) }, 
  //     { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  //   )
  // };

  service.post = function (url, params) {
    return $http.post(
      url,
      $httpParamSerializer(params),
      // params,
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      // { headers: { 'Content-Type': 'application/json' } }
    ).then(function (response) {
      // 다른 곳에서 동일 계정으로 로그인 한 경우. 강제 로그아웃 시킴
      if (response.data && response.data.result && response.data.result === 'EXP') {
        toastr.error('다른 곳에서 로그인하였습니다. 로그아웃됩니다.');
        $state.go('Accounts.login');
      }
      return response;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };




  service.get = function (url) {
    return new Promise((resolve, reject) => {
      $http.get(url).then((data) => {
        resolve(data.data);
      }, (err, status) => {
        reject(err, status);
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    });
  };

  service.proxyGet = function (url) {
    return new Promise((resolve, reject) => {
      $http.get(proxyApiUrl + '?url=' + encodeURIComponent(base64.encode(url)) + '&method=GET').then((data) => {
        resolve(data.data);
      }, (err, status) => {
        reject(err, status);
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    });
  };

  service.getSessionStorage = function (key) {
    let str = sessionStorage.getItem(AppSettings.appName),
      obj = JSON.parse(str);

    if (obj && obj.hasOwnProperty(key)) {
      return obj[key];
    } else {
      return null;
    }
  };

  service.setSessionStorage = function (key, value) {
    let str = sessionStorage.getItem(AppSettings.appName);
    let obj = {};

    if (str) {
      obj = JSON.parse(str);
    }

    obj[key] = angular.copy(value);

    sessionStorage.setItem(AppSettings.appName, JSON.stringify(obj));
  };

  return service;

}

export default {
  name: 'CommonService',
  fn: CommonService
};
